import {
  useResponsiveFontSize,
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/components/Util/reactResponsiveDimensions';
import colors from '@/config/colors';
import { AnonymousStackParamList } from '@/navigations/AnonymousStack';
import { StackScreenProps } from '@react-navigation/stack';
import { Image, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  infoTitleStyle: {
    marginTop: 42,
    marginBottom: 12,
    alignSelf: 'center',
    color: colors.darkGrey,
    fontSize: 24,
  },
  infoTextStyle: {
    alignSelf: 'center',
    color: colors.darkGrey,
    fontSize: 16,
    textAlign: 'center',
  },
});

export function PublicConfirmationPage({
  route,
}: StackScreenProps<AnonymousStackParamList, 'PublicConfirmationPage'>) {
  const responsiveFontSizeValue1 = useResponsiveFontSize(1);
  const responsiveStyles = StyleSheet.create({
    logoWrapper: {
      width: useResponsiveWidth(40),
      height: useResponsiveHeight(10),
      marginTop: responsiveFontSizeValue1,
      alignSelf: 'center',
    },
    logoStyle: {
      resizeMode: 'contain',
      width: '100%',
      height: '100%',
    },
  });
  return (
    <View style={styles.container}>
      <View style={responsiveStyles.logoWrapper}>
        <Image
          source={require('../assets/neolexon_Logo_ohneClaim.png')}
          style={responsiveStyles.logoStyle}
        />
      </View>
      <Text style={[styles.infoTitleStyle]}>{route.params.title}</Text>
      <Text style={[styles.infoTextStyle]}>{route.params.text}</Text>
    </View>
  );
}
